export default __webpack_public_path__ + "static/media/2t.af70143d.jpg";